<template>
  <div id="certificates">
    <div class="container">
      <div class="container__liner">
        <div id="navigaton">
          <div class="breadcrumbs">
            <a href='/' class="breadcrumbs-item">Главная</a>
            <span class="breadscrumbs-item" >Сертификаты</span>
          </div>
        </div>
        <div class="title">
          <h1 id="pagetitle">
            <span>{{ pageH1 }}</span>
          </h1>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="container__liner">
        <div class="slideshow">
          <div class="slideshow__item">
            <!--<certificate-container
              v-for="(certificate, index) in certificates"
              :key="index"
              :initData="certificate"
            /> -->

            <slider-certificates
                v-for="group in certificateGroups"
                :id="group.id"
                :key="group.id"
                :title="group.title"
                :response="group"
                @link-index="indexModal = $event.index"
            />

          </div>
        </div>
      </div>

      <modal-gallery
          v-for="group in certificateGroups"
          :id="group.id"
          :key="`modal-${group.id}`"
          :index="indexModal"
          :initData="group"
          :thisDocuments="true"
      />

    </div>
    <widget-map />
  </div>
</template>

<script>
import WidgetMap from '../components/WidgetMap'
import SliderCertificates from '../components/SliderCertificates'
import ModalGallery from '../components/ModalGallery.vue'
import { fetchCertificateGroups } from '../api/adminBrands'
import { metaFromSeoOrDefaults } from '../seo/metaFromStore'

export default {
  name: 'certificates-container',
  components: {
    WidgetMap,
    ModalGallery,
    SliderCertificates
  },
  data() {
    return {
      certificateGroups: [],
      indexModal: 0
    }
  },
  computed: {
    pageH1() {
      const s = this.$store.state.seoPage
      if (s && s.id && s.h1) {
        return s.h1
      }
      return 'Сертификаты'
    },
  },
  methods: {
    handlerCert(event, data) {
      this.index = event.index
      this.data = data
    }
  },
  async beforeMount() {
    this.certificateGroups = (await fetchCertificateGroups().catch(() => []))
      .filter((group) => group && group.count && group.title)
  },
  metaInfo() {
    return metaFromSeoOrDefaults(this.$store, {
      title: 'Сертификаты',
    })
  },
}
</script>